import React, { useEffect, useRef, useState } from "react";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  RSelect,
} from "../../components/Component";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import queryString from 'query-string';

import * as moment from "moment";
import { NumericFormat } from "react-number-format";
import { useHistory, useLocation } from "react-router-dom";
import ReactToPrint from "react-to-print";
import { Button } from "reactstrap";
import DatePicker from "../../components/range-date-picker/RangeDatePicker";
import Table from "../../components/react-table/Table";
import { useUser } from "../../context/user";

import { GET } from "../../helper/api";
import { COMPANY_FULL_INFO, INGREDIENT_CATEGORY_ID, renderPageStyle } from "../../utils/Utils";
import { getToken } from "../../helper/auth";


const BillStation = () => {
  const {
    state: {
      user,
    },
  } = useUser();
  const printRef = useRef();

  const [data, setData] = useState([]);


  const history = useHistory();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [loading, setLoading] = useState(false);
  const [smOption, setSmOption] = useState(false);
  const [warehouseOptions, setWarehouseOptions] = useState([]);
  const [timeNow, setTimeNow] = useState();

  const [summary, setSummary] = useState({});
  const [rangeDate, setRangeDate] = useState({
    startDate: moment(searchParams.get("startDate") || undefined).startOf('days').toDate(),
    endDate: moment(searchParams.get("endDate") || undefined).endOf('days').toDate(),
  });

  const [filter, setFilter] = useState({
    warehouseId: searchParams.get("warehouseId") || undefined,
  });

  const onRangeChange = (dates) => {
    const [startDate, endDate] = dates;
    setRangeDate({
      startDate: startDate ? moment(startDate)?.startOf('days').toDate() : startDate,
      endDate: endDate ? moment(endDate)?.endOf('days').toDate() : endDate
    });
    if (startDate && endDate) {
      setTimeNow(moment().valueOf());
    }
  };

  const colTable = [
    {
      Header: "Mã",
      accessor: "id",
    },
    {
      Header: "Ngày",
      accessor: (item) => moment(item.createdAt).format('DD/MM/YYYY HH:mm:ss')
    },
    {
      Header: "Hàng hoá",
      accessor: (item) => item?.ingredient?.name || "",
    },
    {
      Header: "Loại",
      accessor: (item) => item?.typeName,
    },
    {
      Header: "KH/NCC",
      accessor: (item) => item?.customer?.name || "",
    },
    {
      Header: "KL Hàng(kg)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        value={item.type === 'IN' ? item?.destinationMerchandiseWeight : item?.departureMerchandiseWeight}
        displayType={'text'}
        decimalScale={2}
        thousandSeparator={','}
        thousandsGroupStyle="thousand"
      />,
    },
    {
      Header: "Ghi chú",
      accessor: (item) => "",
    }
  ];

  useEffect(() => {
    const newParams = new URLSearchParams({
      startDate: moment(rangeDate.startDate).toDate(),
      endDate: moment(rangeDate.endDate).toDate(),
      ...(filter.warehouseId ? { warehouseId: filter.warehouseId } : {}),
    });
    history.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    })
    getData();
  }, [filter, timeNow]);


  useEffect(() => {
    GET("/warehouse", {}, true).then((resp) => {
      setWarehouseOptions(
        resp.data?.rows?.map(
          (c) =>
          ({
            label: c.name,
            value: c.id,
            data: c,
          })
        )
      );
    });
  }, []);

  // function to close the form modal

  const getData = () => {
    setLoading(true);
    setData([]);

    let params = {
      startDate: moment(rangeDate.startDate).toDate(),
      endDate: moment(rangeDate.endDate).toDate(),
      ingredientId: Object.values(INGREDIENT_CATEGORY_ID),
      ...(filter.warehouseId ? { warehouseId: filter.warehouseId } : {}),
    };
    GET(`bill`, params, true)
      .then(({ data }) => {
        let summary = {
          finalMerchandiseWeight: 0
        };
        setData(data.rows.map(item => {
          const finalMerchandiseWeight = item.type === 'IN' ? item?.destinationMerchandiseWeight : item?.departureMerchandiseWeight;
          summary.finalMerchandiseWeight += finalMerchandiseWeight;
          return {
            ...item,
            finalMerchandiseWeight
          }
        }));
        setSummary(summary);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const exportExcel = () => {
    const params = queryString.stringify({
      startDate: moment(rangeDate.startDate).toDate(),
      endDate: moment(rangeDate.endDate).toDate(),
      ingredientId: Object.values(INGREDIENT_CATEGORY_ID),
      ...(filter.warehouseId ? { warehouseId: filter.warehouseId } : {}),
      token: getToken(),
    }, { arrayFormat: 'bracket' })
    const url = `${process.env.REACT_APP_API_URL}/api/v1/bill/get-list-bill-station-excel?${params.toString()}`;
    window.open(url, '_blank')
  };


  return (
    <React.Fragment>
      <Head title="Quản lý đơn hàng"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Đơn hàng</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div className="form-control-wrap">
                        <DatePicker
                          selected={rangeDate.startDate}
                          startDate={rangeDate.startDate}
                          onChange={onRangeChange}
                          endDate={rangeDate.endDate}
                          maxDate={new Date()}
                          selectsRange
                          className="form-control date-picker"
                        />
                      </div>
                    </li>
                    <li>
                      <div className="form-group">
                        <div className="form-control-wrap">
                          <RSelect
                            isClearable
                            placeholder={"Lọc theo kho"}
                            options={warehouseOptions}
                            value={warehouseOptions.find((c) => c.value === filter.warehouseId) || null}
                            onChange={(val) => {
                              setFilter({
                                ...filter,
                                warehouseId: val?.value || undefined,
                              });
                            }}
                          />
                        </div>
                      </div>
                    </li>
                    <li>
                      <div
                        className="form-control-wrap"
                      >
                        <ReactToPrint
                          trigger={() => <Button className={`btn btn-secondary`}>In</Button>}
                          content={() => printRef.current}
                          pageStyle={``}
                        />
                      </div>

                    </li>
                    <li>
                      <div>
                        <Button
                          color="secondary"
                          onClick={exportExcel}
                        >
                          <span>Xuất excel</span>
                        </Button>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <div className="my-3" ref={printRef}>
                  <style>{renderPageStyle({
                    fontSize: 15,
                    orientation: "portrait",
                    margin: 15,
                  })}</style>

                  <div className="print-area">
                    <h5>{COMPANY_FULL_INFO?.name}</h5>
                    <h5>Địa chỉ: {COMPANY_FULL_INFO?.address}</h5>
                    <h5>MST: {COMPANY_FULL_INFO?.taxCode}</h5>
                    {filter.warehouseId && <h5>Kho: {warehouseOptions.find((c) => c.value === filter.warehouseId)?.label}</h5>}
                  </div>
                  <h5 className="text-center mt-2 mb-2">Báo cáo Nhập/ Xuất ngày {moment(rangeDate.startDate).format('DD/MM/YYYY')}{!!rangeDate.endDate && moment(rangeDate.startDate).format('DD/MM/YYYY') !== moment(rangeDate.endDate).format('DD/MM/YYYY') ? <>đến {moment(rangeDate.endDate).format('DD/MM/YYYY')}</> : ''} </h5>

                  <Table
                    notShowPagi
                    loading={loading}
                    columns={colTable}
                    data={data}
                    headerRow={(
                      <tr className="nk-tb-item odd font-weight-bold">
                        <td colSpan={5} className="nk-tb-col">
                          <span> Tổng kết ({data?.length || 0} đơn) </span>
                        </td>
                        <td className="nk-tb-col text-right">
                          <NumericFormat
                            value={summary?.finalMerchandiseWeight || 0}
                            displayType={'text'}
                            decimalScale={2}
                            thousandSeparator={','}
                            thousandsGroupStyle="thousand"
                          />

                        </td>
                        <td></td>
                      </tr>
                    )}
                    customRow={() => (
                      <tr>
                        <td colSpan={100} className="nk-tb-col">
                          <div className="print-area sign-print">
                            <div className="d-flex justify-content-end">
                              <div className="pr-5">
                                <h5>Ngày {rangeDate.startDate && moment(rangeDate.startDate).format('DD/MM/YYYY')}</h5>
                                <h5>Thủ kho ký tên</h5>
                                <div style={{ height: '100px' }}></div>
                                <h6 className="text-italic">{user?.name}</h6>




                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                  ></Table>

                </div>
              </div>
            </div>
          </div>
        </Block>
      </Content>


    </React.Fragment>
  );
};

export default BillStation;
